import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { HttpClientModule } from "@angular/common/http";





//import { BsDropdownModule } from "ngx-bootstrap/dropdown";
//import { ProgressbarModule } from "ngx-bootstrap/progressbar";
//import { TooltipModule } from "ngx-bootstrap/tooltip";
//import { CollapseModule } from "ngx-bootstrap/collapse";
//import { TabsModule } from "ngx-bootstrap/tabs";
//import { PaginationModule } from "ngx-bootstrap/pagination";
//import { AlertModule } from "ngx-bootstrap/alert";
//import { BsDatepickerModule } from "ngx-bootstrap/datepicker";
//import { CarouselModule } from "ngx-bootstrap/carousel";
//import { ModalModule } from "ngx-bootstrap/modal";

import { PagesModule } from "./pages/pages.module";

//import { IndexComponent } from "./pages/index/index.component";
//import { ProfilepageComponent } from "./pages/examples/profilepage/profilepage.component";
//import { RegisterpageComponent } from "./pages/examples/registerpage/registerpage.component";
//import { LandingpageComponent } from "./pages/examples/landingpage/landingpage.component";
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { Prestadores } from './pages/examples/prestadores/prestadores.service';
import { WpService } from './wp.service';




@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,    
    // IndexComponent,
    // ProfilepageComponent,
    // RegisterpageComponent,
    // LandingpageComponent
  ],
  imports: [
    BrowserAnimationsModule,
    FormsModule,
    HttpClientModule,
    RouterModule,     
    AppRoutingModule,
    
    // BsDropdownModule.forRoot(),
    // ProgressbarModule.forRoot(),
     //TooltipModule.forRoot(),
     //CollapseModule.forRoot(),
    // TabsModule.forRoot(),
    PagesModule,
    // PaginationModule.forRoot(),
    // AlertModule.forRoot(),
    // BsDatepickerModule.forRoot(),
     //CarouselModule.forRoot(),
    // ModalModule.forRoot()
  ],
  providers: [Prestadores, WpService],
  bootstrap: [AppComponent]
})
export class AppModule {}
